export const MenuList = [
    { id: 1, name: '메인', to: '/' },
    { id: 2, name: '서비스 소개', to: '/introduce' },
    { id: 3, name: '통계', to: '/statistics' },
  ];
  